import React from 'react'
import styled from 'styled-components'

import { RowBetween } from '../../Row'
import AddLiquiditySettingsTab from './AddLiquiditySettingsTab'
import { TYPE } from 'theme'
import V2V3Switch from './V2V3Switch/V2V3Switch'

export const Tabs = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  border-radius: 3rem;
  justify-content: flex-end;
`

export function AddLiquidityAddRemoveTabs() {
  return (
    <>
      <Tabs>
        <RowBetween style={{ padding: '0 1rem 0 1rem' }}>
          <TYPE.mediumHeader fontWeight={500} fontSize={24}>
            New position
          </TYPE.mediumHeader>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <V2V3Switch />
            <AddLiquiditySettingsTab />
          </div>
        </RowBetween>
      </Tabs>
    </>
  )
}
